require('../profile.scss');
var IDM = require('../idm');
var helper = require('../profile-helper');
var utils = require('src/creative/pricing-lead-form/utils');
var profileValidator = require('../validation');

function init(firebase) {
    var signUpDrawerSelector = '#sign-up-drawer';
    var signUpForm = $('#sign-up-form');
    var formErrorSelector = '#sign-up-form-error';

    signUpForm.on('submit', function(e) {
        e.preventDefault();

        var form = e.target;
        if (profileValidator.isFormValid(signUpForm)) {
            return firebase.auth().createUserWithEmailAndPassword(form.email.value, form.password.value).then(function(user) {
                helper.sendEmailVerification(user);
                return IDM.updateProfile(form, user._lat)
                    .always(function(data) {
                        if(data.statusText === 'Created') {
                            utils.switchToDrawer(signUpDrawerSelector, '#sign-up-welcome-drawer');
                        }
                    });
            }).catch(function(error) {
                return profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    signUpForm.on('blur', 'input', function(e) {
        var input = e.target;
        profileValidator.validateField(signUpForm, input, formErrorSelector);
    });
}

module.exports = {
    init: init
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/sign-up/sign-up-drawer.js
// module id = 81
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14